const splitRegexp = /\.|\[(\d+)\]/;
export default class Store {
    constructor(data) {
        /*
         * A Map, not an object: a key like "toString" or "constructor" would otherwise hit
         * Object.prototype and be returned as a cache hit, putting a native function where the
         * looked-up value should be. Using `has` also lets undefined results be cached.
         */
        this.cache = new Map();
        this.data = data;
    }
    get(key) {
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        const path = key.split(splitRegexp).filter((value) => value && value.length);
        let value = this.data;
        for (let i = 0; i < path.length; i += 1) {
            /*
             * Own properties only: a key like "toString" or "constructor" would otherwise resolve to
             * the inherited Object.prototype member and put a native function into the document.
             */
            if (value === null || typeof value !== 'object' || !Object.prototype.hasOwnProperty.call(value, path[i])) {
                value = undefined;
                break;
            }
            value = value[path[i]];
            if (!value) {
                break;
            }
        }
        this.cache.set(key, value);
        return value;
    }
}
